export default __webpack_public_path__ + "static/assets/f1aef4aa7886cbb07e894c5126a0bdfa.png";